import styled from "styled-components";
import { Flex, RATypography } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { Row, Col, Divider, Grid } from "antd";
import { useState, useEffect, useRef } from "react";
import { useTrackVisibility } from "react-intersection-observer-hook";
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

import { getSettings } from "@/stores/slices/settingSlice";
import { AircraftDropdown } from "./AircraftDropdown";
import { AircraftDropdownTablet } from "./AircraftDropdownTablet";
import { AircraftDropdownMobile } from "./AircraftDropdownMobile";
import { SEChevronLeft, SEChevronRight } from "@/components/svgs";

const { useBreakpoint } = Grid;

export function HomeFleets({ step_aboard_our_fleet = {}, snap = false }) {
	const { sm, md, lg, xl } = useBreakpoint();
	const categoryLeftRef = useRef(null);
	const categoryRightRef = useRef(null);

	const [ref, { isVisible }] = useTrackVisibility();
	const { aircraft_categories = [] } = useSelector(getSettings);
	const [selectedCategory, setSelectedCategory] = useState(null);
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (isVisible) {
			setVisible(true);
		}
	}, [isVisible]);

	return (
		<HomeFleetsContainer
			style={{
				height: snap ? "100vh" : "100%",
				opacity: visible ? 1 : 0,
			}}
			ref={ref}
		>
			<Flex alignItems="center" justifyContent="space-between" gap={16} style={{ width: "100%" }}>
				<div className={`${visible && "animate__animated animate__fadeInDown"}`}>
					<WrapperContent>
						<RATypography variant="h2">{step_aboard_our_fleet?.title || ""}</RATypography>
					</WrapperContent>
					<RATypography variant="body3" top="12px" color="#595959" maxLines={4}>
						{step_aboard_our_fleet?.sub_title || ""}
					</RATypography>
				</div>
				<Flex alignItems="center" gap={16} style={sm && !selectedCategory ? { opacity: 1 } : { opacity: 0 }}>
					<CategoryNavigation ref={categoryLeftRef}>
						<SEChevronLeft width="20" height="20" />
					</CategoryNavigation>
					<CategoryNavigation ref={categoryRightRef}>
						<SEChevronRight width="20" height="20" />
					</CategoryNavigation>
				</Flex>
			</Flex>
			<WrapperSection>
				<div
					className={
						selectedCategory
							? "animate__animated animate__fadeOutDown"
							: "animate__animated animate__fadeInUp"
					}
					style={{ width: "100%" }}
				>
					<Swiper
						centeredSlides={sm}
						slidesPerView={xl ? 3 : sm ? 2 : 1.2}
						slidesPerGroup={1}
						spaceBetween={md ? 30 : 16}
						speed={1000}
						modules={[Navigation]}
						navigation={{
							prevEl: categoryLeftRef.current,
							nextEl: categoryRightRef.current,
						}}
					>
						{aircraft_categories?.map((item) => (
							<SwiperSlide key={item._id}>
								<WrapperItem onClick={() => setSelectedCategory(item)}>
									<div>
										<RAImage
											url={item.images[0]?.lowres?.url ?? item.images[0]?.url ?? ""}
											width="100%"
											height="120px"
											objectFit="contain"
										/>
										<RATypography variant="h4" top="24px">
											{item.name}
										</RATypography>
										<RATypography variant="body3" top="4px" color="#595959" maxLines={3}>
											{item.description}
										</RATypography>
									</div>
									<div>
										<Divider />
										<Row justify="space-between">
											<Col span={12}>
												<RATypography variant="body3">Range</RATypography>
												<RATypography variant="sub-heading3" top="4px">
													{`${
														item.min_fly_times_hours > 0
															? `${item.min_fly_times_hours} - `
															: ""
													}${item.max_fly_times_hours} Hrs`}
												</RATypography>
											</Col>
											<Col span={12}>
												<RATypography variant="body3">Passengers</RATypography>
												<RATypography
													variant="sub-heading3"
													top="4px"
												>{`${item.min_passengers || "0"} - ${item.max_passengers || "0"}`}</RATypography>
											</Col>
										</Row>
									</div>
								</WrapperItem>
							</SwiperSlide>
						))}
					</Swiper>
				</div>
				<Row
					className={
						selectedCategory
							? "animate__animated animate__fadeInUp"
							: "animate__animated animate__fadeOutDown"
					}
					style={{
						position: "absolute",
						inset: 0,
						zIndex: selectedCategory ? 1 : -1,
					}}
				>
					{lg ? (
						<AircraftDropdown
							selectedCategory={selectedCategory}
							onSetSelectedCategory={setSelectedCategory}
						/>
					) : md ? (
						<AircraftDropdownTablet
							selectedCategory={selectedCategory}
							onSetSelectedCategory={setSelectedCategory}
						/>
					) : (
						<AircraftDropdownMobile
							selectedCategory={selectedCategory}
							onSetSelectedCategory={setSelectedCategory}
						/>
					)}
				</Row>
			</WrapperSection>
		</HomeFleetsContainer>
	);
}

const HomeFleetsContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	/* padding: 84px 0; */
	overflow: hidden;
	@media (max-width: 991px) {
		padding: 64px 0;
	}

	.swiper-button-disabled svg {
		color: #d6d6d6;
		transition: all 0.4s;
	}
`;
const WrapperContent = styled.div`
	padding: 4px 12px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
const WrapperSection = styled.div`
	width: 100%;
	padding: 30px 0px;
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
`;

const WrapperItem = styled.div`
	width: 100%;
	height: 100%;
	background: #ffffff;
	border-radius: 8px;
	padding: 24px 20px;
	cursor: pointer;
`;

const CategoryNavigation = styled.div`
	width: 30px;
	height: 30px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;

	&:active svg,
	&:active svg {
		color: #ffb11a !important;
	}
`;
